import SignStoreConfig from '../../store/signin/config'

export function parseJson(value, fallback = null) {
  if (!value) return fallback
  try {
    return JSON.parse(value)
  } catch {
    return fallback
  }
}

export function shouldPreserveDirectMobileFlowVaultData() {
  const session = localStorage.getItem(SignStoreConfig.LOCAL_STATES.SESSIONS)
  const mobileFlowSession = localStorage.getItem(SignStoreConfig.LOCAL_STATES.MOBILE_FLOW_SESSION)
  if (!session || mobileFlowSession !== session) {
    return false
  }

  const widgetConfig = parseJson(localStorage.getItem(SignStoreConfig.LOCAL_STATES.WIDGET_CONFIG))
  return widgetConfig?.isWidgetLogin === false && widgetConfig?.isVaultEnabled === false
}

export function safeStringify(value, fallback = '') {
  try {
    return JSON.stringify(value)
  } catch {
    return fallback
  }
}
